import React from 'react';
import { Badge } from 'react-bootstrap';
import {
  WorkflowArea,
  getWorkflowPriorityLabel,
  getWorkflowPriorityVariant,
  getWorkflowStatusLabel,
  getWorkflowStatusVariant,
} from '../../utils/workflowVisuals';

interface WorkflowStatusBadgeProps {
  status: string;
  area?: WorkflowArea;
  className?: string;
}

interface WorkflowPriorityBadgeProps {
  priority: string;
  className?: string;
}

interface WorkflowStepBadgeProps {
  step?: string | null;
  className?: string;
}

export const WorkflowStatusBadge: React.FC<WorkflowStatusBadgeProps> = ({
  status,
  area = 'tickets',
  className = 'dashboard-badge',
}) => (
  <Badge bg={getWorkflowStatusVariant(status)} className={className}>
    {getWorkflowStatusLabel(status, area)}
  </Badge>
);

export const WorkflowPriorityBadge: React.FC<WorkflowPriorityBadgeProps> = ({
  priority,
  className = 'dashboard-badge',
}) => (
  <Badge bg={getWorkflowPriorityVariant(priority)} className={className}>
    {getWorkflowPriorityLabel(priority)}
  </Badge>
);

export const WorkflowStepBadge: React.FC<WorkflowStepBadgeProps> = ({
  step,
  className = 'dashboard-badge dashboard-step-badge',
}) => (
  <Badge bg="secondary" className={className}>
    {step?.trim() ? step : 'Sem etapa'}
  </Badge>
);
